import React from 'react';
import PropTypes from 'prop-types';

import { t } from 'i18next';

import { styled } from '@mui/material/styles';

import { Tooltip } from '@mui/material';

import {
  Button, Dialog,
  DialogActions,
  DialogContent,
  DialogHeader,
  Stack,
  LinearProgress,
} from '@datanomik/commons-ui';
import { ArrowLeftLine, CloseLine } from '@datanomik/commons-ui/icons';

import { useAppContext } from '@/contexts/app';

import styles from './styles';

const ModalRaw = ({
  className,
  openModal,
  closeModal,
  title,
  children,
  primaryButton,
  backModal,
  actionConfirm,
  backdropClose = true,
  DialogProps,
  DialogHeaderProps,
  DialogActionsProps,
  isLoadingKey = 'modal',
  actionConfirmSx = {},
}) => {
  const { isLoading } = useAppContext();

  return (
    <Dialog
      className={className}
      open={openModal}
      onClose={() => {
        if (backdropClose && closeModal) {
          closeModal();
        }
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      {...DialogProps}
    >
      {(DialogHeaderProps || title || backModal || closeModal) && (
        <DialogHeader
          startAdornment={(
            backModal && (
              <Tooltip title={t('Back')}>
                <Button
                  onClick={closeModal}
                  color="black"
                  startIcon={<ArrowLeftLine />}
                  size="xsmall"
                  variant="text"
                />
              </Tooltip>
            )
          )}
          endAdornment={(
            closeModal && (
              <Tooltip title={t('Close')}>
                <Button
                  onClick={closeModal}
                  color="black"
                  startIcon={<CloseLine />}
                  size="xsmall"
                  variant="text"
                />
              </Tooltip>
            )
          )}
          text={t(title)}
          {...DialogHeaderProps}
        />
      )}

      <DialogContent>
        <LinearProgress sx={{ opacity: isLoading[isLoadingKey] ? 1 : 0, height: '2px' }} />
        <Stack p="20px" gap="20px">
          {children}
        </Stack>
      </DialogContent>

      {(DialogActionsProps?.dialogActions || primaryButton) && (
        <DialogActions>
          {DialogActionsProps?.dialogActions}
          {primaryButton && (
            <>
              <Button
                variant="outlined"
                color="black"
                onClick={closeModal}
                fullWidth
              >
                {t('Cancel')}
              </Button>
              <Button
                onClick={actionConfirm}
                variant="contained"
                autoFocus
                fullWidth
                disabled={isLoading[isLoadingKey] || !actionConfirm}
                sx={actionConfirmSx}
              >
                {t(primaryButton)}
              </Button>
            </>
          )}
        </DialogActions>
      )}

    </Dialog>
  );
};

ModalRaw.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  expand: PropTypes.bool,
  openModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func,
  backModal: PropTypes.func,
  primaryButton: PropTypes.string,
  actionConfirm: PropTypes.func,
  icon: PropTypes.object,
  backdropClose: PropTypes.bool,
  DialogProps: PropTypes.object,
  DialogHeaderProps: PropTypes.object,
  DialogActionsProps: PropTypes.object,
  isLoadingKey: PropTypes.string,
};

const Modal = styled(ModalRaw)(styles);

Modal.propTypes = ModalRaw.propTypes;

export default Modal;
